export const LocalStorage = {
    token: {
      get: () => localStorage.getItem('token'),
      set: (value: string) => localStorage.setItem('token', value),
    },
    refreshToken: {
      get: () => localStorage.getItem('refreshToken'),
      set: (value: string) => localStorage.setItem('refreshToken', value),
    },
    userMail: {
        get: () => localStorage.getItem('userInfo.email'),
        set: (value: string) => localStorage.setItem('userInfo.email', value),
      },
      userRole: {
        get: () => localStorage.getItem('userInfo.roles'),
        set: (value: string) => localStorage.setItem('userInfo.roles', value),
      },
      type: {
        get: () => localStorage.getItem('type'),
        set: (value: string) => localStorage.setItem('type', value),
      },
      prCode: {
        get: () => localStorage.getItem('PrCode'),
        set: (value: string) => localStorage.setItem('PrCode', value),
      },
      prName: {
        get: () => localStorage.getItem('PrName'),
        set: (value: string) => localStorage.setItem('PrName', value),
      },
      doName: {
        get: () => localStorage.getItem('DoName'),
        set: (value: string) => localStorage.setItem('DoName', value),
      },
      infoBulleMessage: {
        get: () => JSON.parse(localStorage.getItem('infoBulleMessage')!),
        set: (value: string) => localStorage.setItem('infoBulleMessage', value),
      },
  };